import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import IniciarSesionWith from "./auth/IniciarSesionWith";
import Login from "./auth/Login";
import RestablecerPassword from "./auth/RestablecerPassword";
import ConfirmarCorreoRecuperar from "./auth/ConfirmarCorreoRecuperar";
import CambiarPassword from "./auth/CambiarPassword";
import CambiadoPassword from "./auth/CambiadoPassword";
import CrearCuenta from "./auth/CrearCuenta";
import ConfirmarRegistro from "./auth/ConfirmarRegistro";
import RegistroExitoso from "./auth/RegistroExitoso";
import { useTranslation } from "@hooks/useTranslation";
import { useAuth } from "@context/AuthContext";

// Componente AuthPopup - Layer/Popup (debe estar fuera de Box para poder usar useAuth)


function Box(section) {

  const { translate } = useTranslation();
  const { openAuth } = useAuth();
  
  const renderTitle = (title) => {
    return (
      <div>
        <h5>{title}</h5>
      </div>
    );
  };
  const titles = {
    IniciarSesionWith: renderTitle(translate('login.title')),
    Login: renderTitle(translate('login.title')),
    RestablecerPassword: renderTitle(translate('recovery.title')),
    ConfirmarCorreoRecuperar: renderTitle(translate('recovery.title')),
    CambiarPassword: renderTitle(translate('recovery.change')),
    CrearCuenta: renderTitle(translate('login.create')),
    ConfirmarRegistro: renderTitle(translate('login.confirm_email')),
  };
  const pages = {
    IniciarSesionWith: <IniciarSesionWith />,
    Login: <Login />,
    RestablecerPassword: <RestablecerPassword />,
    ConfirmarCorreoRecuperar: <ConfirmarCorreoRecuperar />,
    CambiarPassword: <CambiarPassword />,
    CambiadoPassword: <CambiadoPassword />,
    CrearCuenta: <CrearCuenta />,
    ConfirmarRegistro: <ConfirmarRegistro />,
    RegistroExitoso: <RegistroExitoso />,
  };
  const footer = (section) => {
    /**
     *
     * ! className='TextColorSec'
     * ? show lines inside as linear gris
     *
     */
    if (
      section == "ConfirmarCorreoRecuperar" ||
      section == "CambiarPassword" ||
      section == "CambiadoPassword" ||
      section == "CrearCuenta" ||
      section == "ConfirmarRegistro"
    ) {
      return null;
    }
    return (
      <div className={section == "RestablecerPassword" ? "TextColorSec" : ""}>
        <p>{translate('login.no_register')} </p>
        <a onClick={() => openAuth('CrearCuenta')} style={{ cursor: 'pointer' }}>
          <b>{translate('login.create')}</b>
        </a>
      </div>
    );
  };
  return (
    <>
      {section == "CambiadoPassword" ? null : titles[section]}
      {pages[section]}
      {footer(section)}
    </>
  );
}

// Componente AuthPopup - Layer/Popup
const AuthPopup = () => {
  const { showAuth, authPage, closeAuth, setAuthPage } = useAuth();
  const navigate = useNavigate();
  const { translate } = useTranslation();

  if (!showAuth) {
    return null;
  }

  return (
    <div className="auth-popup-overlay" onClick={closeAuth}>
      <div className="auth-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="auth-close-btn" onClick={closeAuth} aria-label="Close">
        </button>
        <div className="IniciarSesion">
          <div
            className="ImageIcon ArtOnU"
            style={{ cursor:"pointer" }}
            onClick={() => {
              closeAuth();
              navigate("/home");
            }}
          ></div>
          <div
            className="ImageIcon ArtFans"
            onClick={() => setAuthPage('IniciarSesionWith')}
            style={{ cursor: "pointer" }}
          ></div>
          {authPage !== "RegistroExitoso" && Box(authPage)}
          {authPage === "RegistroExitoso" && <RegistroExitoso />}
        </div>
      </div>
    </div>
  );
};

// Componente para rutas que aún deben ser páginas completas (como cambiar contraseña)
function ReturnAuth(page) {
  const navigate = useNavigate();
  return page == "RegistroExitoso" ? (
    <RegistroExitoso />
  ) : (
    <main className="ContentBox ContentChildCenter FontColorLight TextCenter">
      <div className="IniciarSesion">
        <div
          className="ImageIcon ArtOnU"
          style={{ cursor:"pointer" }}
          onClick={() => navigate("/home")}
        ></div>
        <div
          className="ImageIcon ArtFans"
          onClick={() => navigate("/home")}
        ></div>
        {Box(page)}
      </div>
    </main>
  );
}

const Component = ({ page }) => {
  const location = useLocation().pathname;
  return ReturnAuth(page);
};

export default Component;
export { AuthPopup };
